var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#verified_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 .917 2.75 4.584v5.5c0 5.087 3.52 9.845 8.25 11 4.73-1.155 8.25-5.913 8.25-11v-5.5L11 .917Zm6.417 9.167c0 4.143-2.732 7.965-6.417 9.102-3.685-1.137-6.417-4.959-6.417-9.102V5.775L11 2.925l6.417 2.85v4.309Zm-10.625.54L5.5 11.917l3.667 3.667L16.5 8.25 15.207 6.95l-6.04 6.04-2.374-2.365Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verified_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgVerified;